import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Enum

export enum ActivityTypeEnum {
  attraction = 'attraction',
  other = 'other',
  transport = 'transport',
}

// Model

export class ActivityLiteModel extends CommonModel {
  type: string;
  code: string;
  name: string;
  description: string;
  email: string;
  phone: string;
  phone_2?: string | null;
}

export class ActivityModel extends ActivityLiteModel {}

// Input

export type getActivitiesInput = {
  params: CommonParamInput;
};

export type getActivityInput = {
  id: string;
};

export type ActivityMutationInput = {
  type: string;
  code: string;
  name: string;
  description?: string;
  email: string | null;
  phone: string | null;
  phone_2: string | null;
};

export type ActivityUpdateInput = {
  activityId: string;
  body: ActivityMutationInput;
};

export type ActivityDeleteInput = {
  activityId: string;
};
